"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSectionPutRequest = updateSectionPutRequest;
exports.deleteRoleSectionRequest = deleteRoleSectionRequest;
async function updateSectionPutRequest(userId, branchId, payload) {
    const data = new URLSearchParams(Object.entries(payload).map(([key, value]) => [key, value.toString()]));
    try {
        const url = `/dashboard/${userId}/slot/${payload.id}?c=${branchId}`;
        const response = await fetch(url, {
            method: 'PUT',
            headers: { "Content-Type": "application/x-www-form-urlencoded", },
            body: data.toString(),
        });
        return await response.json();
    }
    catch (err) {
        throw new Error("Failed to update Section");
    }
}
async function deleteRoleSectionRequest(activeUserId, activeBranchId, roleSectionId, roleId) {
    const params = new URLSearchParams();
    params.set('roleID', roleId.toString());
    params.set('sectionRoleID', roleSectionId.toString());
    params.set('c', activeBranchId.toString());
    const url = `/dashboard/${activeUserId}/role_slot_section`;
    const newUrl = `${url}?${params.toString()}`;
    try {
        const response = await fetch(newUrl, {
            method: 'DELETE',
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
